import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "react-bootstrap";
import moment from "moment";

import * as projectActions from "../../../actions/projectActions";
import ProjectService from "../../../services/projectService";

const ProjectProgressReviewSlider = ({
  value = 0,
  projectId,
  disabled,
  fullView,
  auth,
  onProgressUpdate
}) => {
  const [number, setNumber] = useState(() => value);

  useEffect(() => {
    setNumber(value);
  }, [value]);

  const handleChange = (e) => {
    setNumber(e.target.value);
  };

  const updateProject = async () => {
    const fullProject = await ProjectService.getProject(projectId);

    // eslint-disable-next-line no-unused-vars
    const { notes, ...everythingElse } = fullProject;

    const updatedProject = { ...everythingElse };

    const newObj = {
      initial: fullProject.percent_complete.length
        ? fullProject.percent_complete[fullProject.percent_complete.length - 1]
            .value
        : 0,
      value: number,
      created_by: auth.user.full_name,
      date: moment()
    };
    if (parseInt(newObj.initial) !== parseInt(number)) {
      updatedProject.percent_complete.push(newObj);
      await ProjectService.updateProject(updatedProject);

      if (onProgressUpdate) {
        onProgressUpdate(updatedProject._id);
      }
    }
  };

  return (
    <Row className="slidecontainer">
      <Col md={11} className="sliderCol">
        <input
          type="range"
          min="0"
          max="100"
          step="1"
          value={number}
          className="slider"
          id="myRange"
          onInput={handleChange}
          disabled={!!disabled}
          onMouseUp={updateProject}
        />
      </Col>
      <Col md={1} className="sliderTextCol">
        <span>{fullView ? `${number}% Complete` : `${number}%`}</span>
      </Col>
    </Row>
  );
};
ProjectProgressReviewSlider.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  fullView: PropTypes.bool,
  projectId: PropTypes.string,
  auth: PropTypes.object,
  onProgressUpdate: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...projectActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectProgressReviewSlider);
